module.exports = __webpack_public_path__ + "img/picto_close_qrcode.83c12fdc.png";